// src/components/onboarding/ProgressBar.js
import React from 'react';
import { Check } from 'lucide-react';

const ProgressBar = ({ currentStep, labels }) => {
  return (
    <div className="w-full max-w-lg mx-auto mb-8">
      <div className="flex items-center justify-between">
        {labels.map((label, i) => {
          const step = i + 1;
          const isActive = step === currentStep;
          const isDone = step < currentStep;

          return (
            <React.Fragment key={step}>
              <div className="flex flex-col items-center">
                <div
                  className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold transition-all ${
                    isDone
                      ? 'bg-emerald-500 text-white'
                      : isActive
                        ? 'bg-rose-500 text-white shadow-lg'
                        : 'bg-gray-200 dark:bg-gray-700 text-gray-400'
                  }`}
                >
                  {isDone ? <Check size={16} /> : step}
                </div>
                <span
                  className={`text-xs mt-1 hidden sm:block ${
                    isActive ? 'text-rose-600 dark:text-rose-400 font-semibold' : 'text-gray-400'
                  }`}
                >
                  {label}
                </span>
              </div>
              {i < labels.length - 1 && (
                <div
                  className={`flex-1 h-0.5 mx-1 transition-all ${
                    step < currentStep ? 'bg-emerald-500' : 'bg-gray-200 dark:bg-gray-700'
                  }`}
                />
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default ProgressBar;
